<template>
    <div>
        <h3>Account Center &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="用户名" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户uid" prop="uid">
                        <el-input v-model="form.uid"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="注册渠道" prop="register_channel">
                        <el-select v-model="form.register_channel" placeholder="请选择注册渠道">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of channelList" :key="item.key" :label="item.name" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="账户类型" prop="loginProviderId">
                        <el-select v-model="form.loginProviderId" placeholder="请选择账户类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of Object.keys(accountTypes)" :key="item" :label="accountTypes[item]" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="show_name" label="用户名" fixed="left"></el-table-column>
            <el-table-column prop="email" label="账号名" width="200"></el-table-column>
            <el-table-column prop="points" label="剩余积分"></el-table-column>
            <el-table-column prop="consumption_points" label="消耗积分"></el-table-column>
            <el-table-column prop="uid" label="uid" width="280"></el-table-column>
            <el-table-column prop="loginProviderId" label="账号类型">
                <template slot-scope="scope">
                    {{ accountTypes[scope.row.loginProviderId] }}
                </template>
            </el-table-column>
            <el-table-column prop="register_channel" label="注册渠道">
                <template slot-scope="scope">
                    {{ Object.keys(channelObject).length > 0 ? channelObject[scope.row.register_channel] : scope.row.register_channel }}
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="注册时间(UTC)">
                <template slot-scope="scope">
                    {{ $moment(new Date(scope.row.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}
                </template>
            </el-table-column>
            <el-table-column label="创建Prompt权限" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                    <el-popconfirm :title="scope.row.open_create ? '确定 关闭Prompt 创建权限吗？' : '确定 开启Prompt 创建权限吗？'" @confirm="() => confirm(scope.row)">
                        <el-button type="text" size="small" slot="reference">{{ scope.row.open_create ? '关闭' : '开启' }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
            <el-table-column label="详情" fixed="right" width="200" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" slot="reference" :loading="uid === scope.row.uid && detail_loading" @click="handDetail(scope.row)">详情</el-button>
                    <el-button type="text" size="small" slot="reference" @click="handAddPoints(scope.row)">增加积分</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <el-dialog title="用户详情" :visible.sync="dialogFormVisible">
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">用户名:</el-col>
                        <el-col :span="19">{{ detail.show_name }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">账户名:</el-col>
                        <el-col :span="19">{{ detail.email }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">uid:</el-col>
                        <el-col :span="19">{{ detail.uid }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">注册时间:</el-col>
                        <el-col :span="19">{{ $moment(new Date(detail.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">账户类型:</el-col>
                        <el-col :span="19">{{ accountTypes[detail.loginProviderId] }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">注册渠道:</el-col>
                        <el-col :span="19">{{ Object.keys(channelObject).length > 0 ? channelObject[detail.register_channel] : detail.register_channel }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="8">剩余免费优化次数:</el-col>
                        <el-col :span="16">{{ $Met.isSameDay(detail.optimize_info.date, new Date().toISOString()) ? detail.optimize_info.free_count : free_optimize_count }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="8">剩余免费评分次数:</el-col>
                        <el-col :span="16">{{ $Met.isSameDay(detail.score_info.date, new Date().toISOString()) ? detail.score_info.free_count : free_score_count }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Discord:</el-col>
                        <el-col :span="19">{{ detail.discord_link }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Facebook:</el-col>
                        <el-col :span="19">{{ detail.facebook_link }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Github:</el-col>
                        <el-col :span="19">{{ detail.github_link }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Tiktok:</el-col>
                        <el-col :span="19">{{ detail.tiktok_link }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Twitter:</el-col>
                        <el-col :span="19">{{ detail.twitter_link }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">&nbsp;</el-col>
                        <el-col :span="19">&nbsp;</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Prompt:</el-col>
                        <el-col :span="19">{{ detail.prompt_total }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="7">Visual Prompt:</el-col>
                        <el-col :span="17">{{ detail.imgPrompt_total }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Viewed:</el-col>
                        <el-col :span="19">{{ detail.view_total }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Copied:</el-col>
                        <el-col :span="19">{{ detail.copy_total }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Liked:</el-col>
                        <el-col :span="19">{{ detail.focus_total }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Saved:</el-col>
                        <el-col :span="19">{{ detail.collect_total }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Following:</el-col>
                        <el-col :span="19">{{ detail.following_list ? detail.following_list.length : 0 }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">Followers:</el-col>
                        <el-col :span="19">{{ detail.followers_list ? detail.followers_list.length : 0 }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="24">
                    <el-row>
                        <el-col :span="3">个人描述:</el-col>
                        <el-col :span="21">{{ detail.describe }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-dialog>
        <AddPoints />
        <add-points-modal :dialogVisible="addPointsFlag" :userInfo="userInfo" @closeModal="closeAddModal" v-if="addPointsFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import AddPointsModal from './addPoints';
export default {
    data() {
        return {
            sum: 0,
            form: {
                name: '',
                uid: '',
                register_channel: '',
                loginProviderId: '',
            },
            accountTypes: {
                'promptport.ai': 'Promptport',
                'twitter.com': 'Twitter',
                'discord.com': 'Discord',
                'github.com': 'Github',
                'google.com': 'Google',
            },
            channelObject: {},
            channelList: [],
            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,

            // free count
            free_score_count: 0,
            free_optimize_count: 0,

            // dialog
            dialogFormVisible: false,
            detail_loading: false,
            uid: '',
            detail: {
                optimize_info: {},
                score_info: {},
            },

            // addPoints
            addPointsFlag: false,
            userInfo: {},
        };
    },
    components: { AddPointsModal },
    created() {
        this.getChannelList();
        this.getUserList();
        this.get_free_count();
    },
    methods: {
        async getUserDetail(uid) {
            try {
                this.uid = uid;
                this.detail_loading = true;
                const { data } = await serverApi.userDetail({ uid });
                if (data.code !== 0) throw new Error(data.error);
                this.detail = data.data;
                this.dialogFormVisible = true;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.detail_loading = false;
            }
        },
        async getChannelList(_params) {
            try {
                const params = {
                    page: 1,
                    size: 300,
                };
                const { data } = await serverApi.channelList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.channelList = data.data;
                let obj = {};
                this.channelList.forEach(ele => {
                    obj[ele.key] = ele.name;
                });
                this.channelObject = obj;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },
        async getUserList(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.userList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handDetail(data) {
            this.getUserDetail(data.uid);
            // this.detail = data;
            // this.dialogFormVisible= true
        },
        handleCurrentChange(val) {
            this.getUserList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getUserList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getUserList(this.form);
        },

        async get_free_count() {
            try {
                const { data } = await serverApi.getConfig();
                if (data.code !== 0) throw new Error(data.error);
                this.free_score_count = data.data.free_score_count;
                this.free_optimize_count = data.data.free_optimize_count;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },

        async confirm(item) {
            try {
                const params = {
                    uid: item.uid,
                    open_create: !item.open_create,
                };
                const { data } = await serverApi.opencreate(params);
                if (data.code !== 0) throw new Error(data.error);
                this.getUserList();
                this.$message({
                    message: 'Edit success',
                    type: 'success',
                });
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },

        handAddPoints(data) {
            this.userInfo = data;
            this.addPointsFlag = true;
        },

        closeAddModal(isUpdate) {
            this.addPointsFlag = false;
            if (isUpdate) {
                this.getUserList();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
